var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("path",{"strokeLinecap":"round","strokeLinejoin":"round","d":"M15 19l-7-7 7-7"}));
}

ChevronLeft.defaultProps = {"fill":"none","viewBox":"0 0 24 24","strokeWidth":"2","stroke":"currentColor","aria-hidden":"true"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
